/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Manual_DateInputs */

const vi_einvoice_manual_date = /** @type {(inputs: Einvoice_Manual_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hóa đơn`)
};

/**

* @param {Einvoice_Manual_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_manual_date = /** @type {((inputs?: Einvoice_Manual_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Manual_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_manual_date(inputs)
});